import { render, staticRenderFns } from "./VDrawer.vue?vue&type=template&id=dac5287c&scoped=true"
import script from "./VDrawer.vue?vue&type=script&lang=js"
export * from "./VDrawer.vue?vue&type=script&lang=js"
import style0 from "./VDrawer.vue?vue&type=style&index=0&id=dac5287c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac5287c",
  null
  
)

export default component.exports